export default __webpack_public_path__ + "static/media/asset-2.602da14d.png";